/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Create_ButtonInputs */

const en_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Issue`)
};

const fr_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer l'incident`)
};

const de_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem erstellen`)
};

const it_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea problema`)
};

const ru_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать проблему`)
};

const es_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear problema`)
};

const zh_cn2_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建问题`)
};

const ja_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題を作成`)
};

const hi_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या उत्पन्न करें`)
};

const pt_pt2_manual_qc_create_button = /** @type {(inputs: Manual_Qc_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar problema`)
};

/**
* | output |
* | --- |
* | "Create Issue" |
*
* @param {Manual_Qc_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_create_button = /** @type {((inputs?: Manual_Qc_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_create_button(inputs)
	if (locale === "de") return de_manual_qc_create_button(inputs)
	if (locale === "it") return it_manual_qc_create_button(inputs)
	if (locale === "ru") return ru_manual_qc_create_button(inputs)
	if (locale === "es") return es_manual_qc_create_button(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_create_button(inputs)
	if (locale === "ja") return ja_manual_qc_create_button(inputs)
	if (locale === "hi") return hi_manual_qc_create_button(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_create_button(inputs)
	return en_manual_qc_create_button(inputs)
});